import React, { ReactNode } from 'react';

import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { ProductPrice } from 'src/types/global-types';
import { Reviews } from 'src/components/Reviews/reviews.types';

import { ProductDetailLayout } from './ProductDetailLayout';
import { freeReturns, freeShipping } from './ProductTrustMessage';
import { Product } from './utils/product-detail.types';
import classes from './ProductDetail.scss';
import { ProductAttrs } from './utils/product-attrs.types';

export type ProductMainProps = {
    attrs: ProductAttrs;
    price: ProductPrice;
    product: Product;
    reviews: Reviews | null;
    children?: ReactNode;
};

export function ProductMain(props: ProductMainProps) {
    return (
        <>
            <Breadcrumbs breadcrumbs={props.product.breadcrumbs} current={props.product.name} />
            <ProductDetailLayout
                product={props.product}
                media_entries={props.product.media_entries}
                price={props.price}
                reviews={props.reviews}
            >
                {props.attrs.free_shipping && freeShipping}
                {props.children}
                {props.attrs.free_returns && <div className={classes.afterCta}>{freeReturns}</div>}
            </ProductDetailLayout>
        </>
    );
}
